<template>
  <div class="Assets">
    <HeaderReturn title="闪兑">
      <template #right>
        <slot name="right">
          <!-- <van-icon
            @click="goLink('/my/flashExchangeDt')"
            name="todo-list-o"
            size="20"
          ></van-icon> -->
          <span @click="goLink('/my/flashExchangeDt')">历史记录</span>
        </slot>
      </template>
    </HeaderReturn>
    <div class="Assets_header bg">
      <div v-for="(item, index) in Assets_header" :key="index">
        <div>
          <img :src="item.img" alt="" />
          <span>{{ item.txt }}</span>
        </div>
     
      </div>
    </div>
    <div class="Assets_content bg">
      <p>我要兑换</p>
      <!-- 下拉选择框 -->
      <el-input
        type="number"
        v-model="params.amount"
        class="m-y-xs"
        placeholder="请输入兑换数量"
      >
        <div slot="append" class="d-flex">
          <!-- <img :src="baseApi + toCoin+'.png'" alt="" style="width: 20px;height:20px" class="img" /> -->
          <img
            v-if="symbol != 'LQD'"
            :src="'https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/FIL.png'"
            alt=""
            style="width: 20px; height: 20px; margin-right: 10px"
            class="img"
          />
          <img
            v-else
            src="../../assets/img/page/LQD.png"
            alt=""
            style="width: 20px; height: 20px; margin-right: 10px"
            class="img"
          />
          <el-select
            v-model="symbol"
            @change="selectContract"
            class="whiteColor"
          >
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="(item, index) in symbolInfo"
              :key="index"
            ></el-option>
          </el-select>
        </div>
      </el-input>
      <div class="footer">
        <span style="color:#f89b19">!&nbsp;</span> 当前兑换比例：1{{ symbol }}
        可兑换
        <span style="color: #fff">{{ symbol != "LQD" ? fee : "1" }}</span>
        {{ symbol != "LQD" ? "USDT2" : "LDQ1" }}

        <p>
          您当前有：<span style="color: #fff">{{ usableBalance }}</span>
          {{ symbol }}
        </p>
      </div>
    </div>
    <div class="system_btn" @click="flashClick">确认兑换</div>
    <div class="system_dialog">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="90%">
        <!-- <span>此操作将退出登录，是否继续？</span> -->
        <div>
          <el-input v-model="params.jyPassword" placeholder="请输入交易密码">
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon } from "vant";
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      Assets_header: [
        {
          img: "https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/FIL.png",
          txt: "FIL",
        },
        {
          img: require("../../assets/img/page/shandui2.png"),
          txt: "",
        },
        {
          img: "https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/USDT.png", //require('../../assets/img/page/LQD.png')
          txt: "USDT2",
        },
      ],
      symbol: "FIL",
      symbolInfo: [
        {
          name: "FIL",
        },
        {
          name: "LQD",
        },
      ],
      params: {
        amount: "",
        fromCoinId: "3",
        jyPassword: "",
        toCoinId: "2",
      },
      usableBalance: 0,
      dialogVisible: false,
      fee: 0,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.Init();
  },
  methods: {
    //确认兑换提示
    flashClick() {
      if (this.params.amount < 0 || this.params.amount == "") {
        this.$toast("数量不能为空或者小于0");
        return;
      }

      if (this.usableBalance < this.params.amount) {
        this.$toast("可用数量必须大于兑换数量");
        return;
      }
      this.dialogVisible = true;
    },
    // 确定闪兑
    qd() {
      mainApiData.flashExchange(this.params).then((res) => {
        console.log("res :>> ", res);
        if (res.data.code == 200) {
          this.$toast("闪兑成功");
          this.dialogVisible = false;
          this.Init();
        } else {
          this.$toast(res.data.msg);
          this.dialogVisible = false;
          this.Init();
        }
      });
    },
    selectContract(val) {
      console.log(val,'2222');
      
      if (this.symbol != "LQD") {
        this.Assets_header = [
          {
            img: "https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/FIL.png",
            txt: "FIL",
          },
          {
            img: require("../../assets/img/page/shandui2.png"),
            txt: "",
          },
          {
            img: "https://qhzx-kline2.oss-ap-southeast-1.aliyuncs.com/logos/USDT.png", //require('../../assets/img/page/LQD.png')
            txt: "USDT2",
          },
        ];
        this.params.fromCoinId = 3;
        this.params.toCoinId = 2;
      } else {
        this.params.fromCoinId = 4;
        this.params.toCoinId = 7;
        this.Assets_header = [
          {
            img: require("../../assets/img/page/LQD.png"),
            txt: "LQD",
          },
          {
            img: require("../../assets/img/page/shandui2.png"),
            txt: "",
          },
          {
            img: require("../../assets/img/page/LQD.png"), //require('../../assets/img/page/LQD.png')
            txt: "LQD1",
          },
        ];
      }

      this.Init();
    },
    Init() {
      // mainApiData.getAllCoin().then((res) => {
      //     console.log('res :>> ', res);
      //     if (res.data.code == 200) {
      //         this.symbolInfo = res.data.data;
      //     }
      // })
      mainApiData
        .getAssetsByCoinName({
          coinName: this.symbol,
        })
        .then((res) => {
          this.usableBalance = res.data.data.usableBalance;
        });
      mainApiData
        .lastPrice({
          coinName: "FIL",
        })
        .then((res) => {
          this.fee = res.data.data;
        });
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path, item) {
      if (path) {
        this.$router.push({
          path,
          query: {
            item: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

::v-deep .van-nav-bar__right {
  color: #f89b19;
  font-size: 12px;
}
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.Assets {
  margin: 50px 10px;
  color: #ffffff;

  .system_dialog {
    ::v-deep .el-dialog__wrapper {
      background: #090101;
      opacity: 0.8;
    }

    ::v-deep .el-input__inner {
      background: transparent;
      border: 0.5px solid #f89b19;
    
      border-radius: 4px;
      color: #fff;
    }

    ::v-deep .el-dialog,
    ::v-deep .el-button {
      background: transparent;

      color: #ffffff;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;
     
      border-radius: 4px;
    }

    ::v-deep .el-dialog {
      background: url(../../assets/img/page/TC-345X233.png) no-repeat;
      background-size: 100% 100%;
    }
    ::v-deep .el-dialog__title,
    ::v-deep .el-dialog__body {
      color: #ffffff;
    }
  }

  .system_btn {
    /* Frame 147 */

    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;

    position: fixed;
    width: 89%;

    // height: 42px;
    left: 0px;
    right: 0px;

    // top: 735px;
    bottom: 60px;
    margin: 20px auto 30px auto;

    /* 黄/主题 */

    background: #f89b19;
    border-radius: 4px;
    color: #ffffff;
  }

  ::v-deep .van-nav-bar__title {
    color: #fff;
  }

  .bg {
    background: transparent;
    border: 0.5px solid #f89b19;

    border-radius: 4px;
  }

  .Assets_header {
    width: 95%;
    height: 44px;
    padding: 0 10px;

    margin: 20px auto 30px auto;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 22px;
      height: 22px;

      margin-right: 10px;
    }
  }

  .Assets_header div {
    display: flex;
    align-items: center;
  }

  .Assets_content {
    padding: 15px 18px 12px 7px;
    width: 95%;
    margin: 20px auto 30px auto;

    p {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .footer {
      margin-top: 10px;
      width: 100%;
      color: #7b7b7b;

      p {
        font-size: 14px;
        margin-left: 10px;
      }
    }

    ::v-deep .el-input__inner {
      background: transparent;
      border: 0.5px solid #f89b19;

      border-radius: 4px;
      color: #fff;
    }

    ::v-deep .el-select .el-input__inner {
      background: none;
      border: none;
  
      border-radius: 4px;
    }

    ::v-deep .el-input-group__append,
    ::v-deep .el-input-group__prepend {
      background: transparent;
      border: 0.5px solid #f89b19;
  
      border-radius: 4px;
      border-left: 0px;
      border-left: none;
      cursor: pointer;
    }

    ::v-deep .el-select {
      width: 90px;
    }
  }
}
</style>
